import { useState } from 'react';
import { guaziNavItems } from '@/components/feature/guaziNav';
import { useGuaziSectionHref } from '@/hooks/guaziUseSectionNav';
import { useGuaziSiteConfig } from '@/hooks/guaziUseSiteConfig';

export default function GuaziHeader() {
  const sectionHref = useGuaziSectionHref();
  const { config } = useGuaziSiteConfig();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="guazi-fixed-top z-50 bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-6 h-[64px] md:h-[68px] flex items-center justify-between gap-3">
        {/* 左侧：icon + 域名，本页跳转 */}
        <a
          href={config.siteUrl}
          className="flex items-center gap-2 md:gap-3 cursor-pointer shrink-0"
          aria-label="瓜子影视官网"
        >
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg overflow-hidden shrink-0">
            <img
              src="/images/guazi-app-icon.png"
              alt="瓜子影视APP下载官网图标"
              title="瓜子影视APP下载官网"
              className="w-full h-full object-cover"
            />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-extrabold text-foreground-950 text-[17px] md:text-[19px] tracking-tight">瓜子影视</span>
            <span className="text-[11px] md:text-xs text-foreground-500 mt-0.5">{config.domain}</span>
          </span>
        </a>

        {/* 中间：模块导航（桌面端） */}
        <nav className="hidden md:flex items-center gap-1">
          {guaziNavItems.map((item) => (
            <a
              key={item.id}
              href={sectionHref(item.id)}
              className="px-3.5 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* 右侧：下载按钮（首页下载按钮 1/2） */}
        <div className="flex items-center gap-2">
          <a
            href={config.downloadPagePath}
            className="inline-flex items-center gap-1.5 px-3 md:px-5 py-2 md:py-2.5 bg-primary-500 text-primary-950 text-sm font-bold rounded-md hover:bg-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-2-line text-base" />
            <span className="hidden sm:inline">下载瓜子影视</span>
            <span className="sm:hidden">下载</span>
          </a>
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 hover:bg-background-100 rounded-md transition-colors duration-200 cursor-pointer"
            aria-label="打开导航菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {/* 移动端导航面板 */}
      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav className="flex flex-col">
            {guaziNavItems.map((item) => (
              <a
                key={item.id}
                href={sectionHref(item.id)}
                onClick={() => setMenuOpen(false)}
                className="text-left px-2 py-3 text-sm text-foreground-700 hover:text-primary-600 border-b border-background-100 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}